export const SET_ORIGINS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.origins.data = payload
    state.origins.lastUpdate = new Date()
  }
}
export const SET_ORIGINS_LOADING = (state, payload) => {
  state.origins.loading = payload
}
